import { colors } from '@spritz-finance/ui'
import React from 'react'
import ScrollContainer from 'react-indiana-drag-scroll'
import styled from 'styled-components'

const TAB_BAR_HEIGHT = 64

const TabBarRow = styled.div`
    display: flex;
    justify-content: center;
    background: transparent;
    overflow: visible;
`

const StyledTabBarNew = styled.div`
    height: ${TAB_BAR_HEIGHT}px;
    display: flex;
    box-sizing: border-box;
    background: var(--background-primary, ${colors.white});
    box-shadow: 10px 20px 20px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    padding: 6px 8px;
`

export const TabBarContainer = React.forwardRef<HTMLDivElement, { children?: React.ReactNode }>(
    ({ children }, ref) => {
        return (
            <TabBarRow ref={ref}>
                <StyledTabBarNew>
                    <ScrollContainer style={{ display: 'flex', overflow: 'visible' }}>
                        {children}
                    </ScrollContainer>
                </StyledTabBarNew>
            </TabBarRow>
        )
    }
)
